import { render } from "./NewNote.vue?vue&type=template&id=8f000c1c"
import script from "./NewNote.vue?vue&type=script&lang=js"
export * from "./NewNote.vue?vue&type=script&lang=js"

import "./NewNote.vue?vue&type=style&index=0&id=8f000c1c&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__